import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useApolloClient } from '@apollo/client';

import AuthLayout from 'layouts/auth/auth';
import User2Fa from 'assets/icons/two-factor-auth';

import { UserCredentials, User2FaCode } from './flow';
import { WarningWrapperStyled, WarningMessageStyled } from './signin.styles';

export default () => {
  const [current, setCurrent] = useState(0);
  const [token, setToken] = useState('');
  const { t } = useTranslation();
  const client = useApolloClient();

  useEffect(() => {
    client.cache.reset();
  }, []);

  const handleNext = () => {
    setCurrent(1);
  };

  const flow = [
    {
      id: 'signin_title_credentials',
      title: t('signin_title_credentials'),
      component: (
        <UserCredentials handleNext={handleNext} setToken={setToken} t={t} />
      ),
      titleCentered: true,
      showPattern: true
    },
    {
      id: 'signin_title_2fa',
      title: t('signin_title_2fa'),
      icon: User2Fa,
      component: <User2FaCode token={token} t={t} />
    }
  ];
  return (
    <>
      {process.env.REACT_APP_MAINTENANCE_MESSAGE_ENABLED === 'true' &&
        Boolean(process.env.REACT_APP_MAINTENANCE_MESSAGE) && (
          <WarningWrapperStyled>
            <div>
              <b>Heads up - </b>
              <WarningMessageStyled>
                {process.env.REACT_APP_MAINTENANCE_MESSAGE}
              </WarningMessageStyled>
            </div>
          </WarningWrapperStyled>
        )}
      <AuthLayout showAlerts={true} {...flow[current]}>
        {flow[current].component}
      </AuthLayout>
    </>
  );
};
